import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-com-reminder-dialog',
  templateUrl: './com-reminder-dialog.component.html',
  styleUrls: ['./com-reminder-dialog.component.css']
})
export class ComReminderDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
